import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
export const Home = () => {
  return <div className="w-full h-screen banner">Home</div>;
};
